export enum PayrollReportingCategory {
  Unknown = 0,
  Taxes = 1,
  Insurance = 2,
  Benefits = 3
}

export const PayrollReportingCategoryMapping: Record<
  PayrollReportingCategory,
  string
> = {
  [PayrollReportingCategory.Unknown]: 'Unknown',
  [PayrollReportingCategory.Taxes]: 'Taxes',
  [PayrollReportingCategory.Insurance]: 'Insurance',
  [PayrollReportingCategory.Benefits]: 'Benefits'
};
